import { render, staticRenderFns } from "./OrdemServicoSettings.vue?vue&type=template&id=575902b8"
import script from "./OrdemServicoSettings.vue?vue&type=script&lang=js"
export * from "./OrdemServicoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports